class PackageCard extends HTMLElement {
    constructor() {
        super();
        
        this.productID = 46515399753914;

    }

    async connectedCallback() {
        this.quantityInput = this.querySelector('.package-card__quantity-input');
        if (this.quantityInput) {
            this.productID = Number(this.dataset.variantId);
            this.confirmedQuantity = Number(this.quantityInput.value);
            this.removeButton = this.querySelector('.package-card__remove');
            this.quantityInput.addEventListener('change', () => this.setQuantity());
            this.removeButton.addEventListener('click', (event) => {
                event.preventDefault();
                if (this.updating) return;
                this.quantityInput.value = 0;
                this.setQuantity();
            });
            return;
        }

        // Keep the cart page's existing checkbox working.
        this.checkbox = this.querySelector('.package-card__checkbox-input');
        if(!this.checkbox) return;

        this.checkbox.addEventListener('change', () => {
            const state = this.checkbox.checked;
            
            if(state) {
                const cartURL = window.Shopify.routes.root + "cart/add.js";
                const formData = { 'items': [{ 'id': this.productID, 'quantity': 1} ]};
                const requestConfig = { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}

                fetch(cartURL, requestConfig)
                .then(req => req.json())
                .then(res => console.log(res))
                .catch(error => console.log(error))
                .finally(() => {
                    this.updateCartQuantity();
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: "package-card" });
                });
            } else {
                this.removeItem();
            }
        });
    }

    async setQuantity() {
        if (this.updating) return;

        const rawValue = this.quantityInput.value.trim();
        let quantity = Number(rawValue);
        if (rawValue === '' || !Number.isSafeInteger(quantity)) {
            this.quantityInput.value = this.confirmedQuantity;
            return;
        }
        quantity = Math.max(0, quantity);
        this.quantityInput.value = quantity;
        if (quantity > 0 && !this.quantityInput.checkValidity()) {
            this.quantityInput.value = this.confirmedQuantity;
            return;
        }
        // Zero on the offer card is a valid no-op, never an add request.
        if (quantity === this.confirmedQuantity) return;

        const cartItems = this.closest('cart-drawer-items');
        const cartDrawer = this.closest('cart-drawer');
        if (!cartItems || !cartDrawer) return;

        this.updating = true;
        this.setAttribute('aria-busy', 'true');
        const controls = this.querySelectorAll('button, input');
        controls.forEach(control => control.disabled = true);
        const line = this.quantityInput.dataset.index;
        const errorElement = document.getElementById('CartDrawer-CartErrors');
        if (errorElement) errorElement.textContent = '';

        try {
            if (line) {
                // Existing lines use the normal removal, totals and cart-rule flow.
                await cartItems.updateQuantity(line, quantity, this.quantityInput.name);
                this.confirmedQuantity = Number(this.quantityInput.value);
                return;
            }

            if (quantity === 0) return;
            cartItems.enableLoading(0);
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{ id: this.productID, quantity }],
                    sections: cartDrawer.getSectionsToRender().map(section => section.id),
                    sections_url: window.location.pathname
                })
            });
            const state = await response.json();
            if (!response.ok || state.errors) {
                throw new Error(state.description || state.message || window.cartStrings.error);
            }

            // Refresh the whole drawer, including totals and the header count.
            if (cartDrawer.getSectionsToRender().every(section => state.sections?.[section.id])) {
                cartDrawer.renderContents(state, false);
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
            } else {
                // Shopify can succeed while returning null for a rendered section.
                await cartItems.onCartUpdate();
                await this.updateCartQuantity();
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
            }
        } catch (error) {
            this.quantityInput.value = this.confirmedQuantity;
            if (!line) {
                // A stock error can still add part of the requested quantity.
                // Re-read the cart so the zero offer cannot hide an added bag.
                try {
                    await cartItems.onCartUpdate();
                    await this.updateCartQuantity();
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
                } catch (refreshError) {
                    console.error('Unable to reconcile the bag quantity:', refreshError);
                }
            }
            const currentErrorElement = document.getElementById('CartDrawer-CartErrors');
            if (currentErrorElement) currentErrorElement.textContent = error.message || window.cartStrings.error;
        } finally {
            cartItems.disableLoading(line || 0);
            controls.forEach(control => control.disabled = false);
            this.removeAttribute('aria-busy');
            this.updating = false;
        }
    }

    async removeItem() {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();

            console.log("CART:", cart);

            const item = cart.items.find(
                (i) => i.variant_id === this.productID
            );

            if (!item) return;

            const cartURL = window.Shopify.routes.root + "cart/change.js";

            const formData = {
                id: item.key, // IMPORTANT: safest identifier
                quantity: 0
            };

            const requestConfig = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            };

            fetch(cartURL, requestConfig)
            .then((req) => req.json())
            .then((res) => console.log(res))
            .catch((error) => console.log(error))
            .finally(() => {
                this.updateCartQuantity();
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "package-card" });
            });

        } catch (error) {
            console.log("REMOVE ERROR:", error);
        }
    }

    async updateCartQuantity() {
        const headerQuantity = document.querySelector('#cart-icon-bubble .wt-header__panel__counter');
        const drawerQuantity = document.querySelector('#cart-drawer-quantity-bubble');

        const res = await fetch('/cart.js');
        const cart = await res.json();

        if(headerQuantity) headerQuantity.innerHTML = cart.item_count;
        if(drawerQuantity) drawerQuantity.innerHTML = `(${cart.item_count})`;

    }

}

if(!customElements.get('package-card')) customElements.define('package-card', PackageCard);
